$('.ht-mobile-expanderTitleContainer').on('click', function () {
  $(this).toggleClass('ht-mobile-expanderTitleContainer-expanded');
  $(this)
    .parent('.ht-mobile-expanderContainer')
    .toggleClass('ht-mobile-expanderContainer-expanded');
  $(this)
    .parent('.ht-mobile-expanderContainer')
    .find('.ht-mobile-expanderDetails')
    .toggleClass('ht-mobile-expanderDetails-expanded');
  $(this).find('.fa-plus').toggleClass('fa-minus');
});
